module.exports = __webpack_public_path__ + "img/order-icon.c1e66acf.png";